<template>
  <v-container class="support-container">
    <v-row>
      <v-col xs="12" align="left" light>
        <p class="title">FAQs</p>
        <v-expansion-panels
          :accordion="accordion"
          :popout="popout"
          :inset="inset"
          :multiple="multiple"
          :focusable="focusable"
          :disabled="disabled"
          :readonly="readonly"
          :flat="flat"
          :hover="hover"
          :tile="tile"
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="faq-question">
              How do I install Saga Dashboard?
            </v-expansion-panel-header>
            <v-expansion-panel-content class="faq-answer">
              <p>Saga Dahsboard currently only runs on a Chrome browser.</p>
              <p>Simply click the button below to install Saga Dashboard. If no button appears then Saga Dashboard is not available on your browser...yet.</p>
              <div class="text-center">
                <v-btn class="ma-2 nobtn" outlined color="blue"><v-icon>mdi-google-chrome</v-icon> Chrome Extension Coming Soon</v-btn><br />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="faq-question">
              How do I uninstall Saga Dashboard?
            </v-expansion-panel-header>
            <v-expansion-panel-content class="faq-answer">
              <p>Sorry to hear you want to uninstall Saga Dashboard</p>
              <p>Uninstalling is easy. In your browser address bar simply type in <code>chrome://extensions</code> and you will be able to uninstall Saga Dashboard from there.</p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="faq-question">
              What permissions does Saga Dashboard require?
            </v-expansion-panel-header>
            <v-expansion-panel-content class="faq-answer">
              <p>We require a few permissions when you install Saga Dashboard.</p>
              <p><code>Replace the page you see when opening a new tab</code><br /><span class="caption">The sole purpose o the Saga Dashboard CHrome Extention is to replace your cuttent default tab with a personalised dashboard. This permission is required to do so</span></p>
              <p><code>Read and change your browsing history</code><br /><span class="caption">Currently unused. We have plans to release a widget that allows you to see your recently visited sites which would use this permission. We have no plans, needs or desires to <em>change</em> your bookmarks.</span></p>
              <p><code>Read and change your bookmarks</code><br /><span class="caption">Currently unused. We have plans to release a widget that allows you to see your bookmarks. We have no plans, needs or desires to <em>change</em> your bookmarks.</span></p>
              <p><code>Detect your physical location:</code><br /><span class="caption">This is used to populate the Longitude and Latitude for widgets which require a location such as Weather.</span></p>
              <p><code>Manage your apps, extensions, and themes:</code><br /><span class="caption">This is required to keep your language preference and a copy of todays background image along with some stuff our database checks that look like gibberish</span></p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="faq-question">
              Does Saga Dashboard track my location?
            </v-expansion-panel-header>
            <v-expansion-panel-content class="faq-answer">
              <p>No. Currently we do not track your location.</p>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="faq-question">
              Why are many features not available to me?
            </v-expansion-panel-header>
            <v-expansion-panel-content class="faq-answer">
              <p>Saga Dashboard has tiers of membership. The Free plan has some features disabled. Its easy and cheap to upgrade to the PRO plan.</p>
              <div class="text-center">
              <v-btn outlined color="blue" large to="/subscribe">
                {{ $t('widgets.subscribe.getPro') }}
              </v-btn>
            </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.support-container {
  background-color: white;
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  .faq-answer {
    p {
      width: 100%;
    }
  }
}
</style>